import api from "@/lib/api";

export async function transferirServico(id, setor, servico) {
  const { data } = await api.post(
    "/secretaria-digital/monitoring/transferir-servico",
    {
      id,
      setor,
      servico,
    },
  );
  return data;
}
